import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import NoticeTextInput from "components/complex/nationalNotice/components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "components/complex/nationalNotice/components/inputs/NoticeGlossaryInput";
import NoticeNumericInput from "components/complex/nationalNotice/components/inputs/NoticeNumericInput";
import FormTranslationContext from "context/FormTranslationContext";
import annulaReportClasses from "../../constants/annulaReportClasses";

function AnnualReportExceptionEditForm(
    {
        entry,
        newEntry,
        buttonWorks,
        reportStep,
        formikProps
    }) {
    const {getDict} = useContext(FormTranslationContext);
    const classes = annulaReportClasses();
    return (<>
        <NoticeGlossaryInput
            className={classes.exceptionChip}
            label={`mmia.${reportStep}.type`}
            id="type"
            formikProps={formikProps}
            items={getDict("SL.MMiA.063").map((item, index) => ({
                label: index + " - " + item.label,
                value: item.value
            }))}
            disabled={buttonWorks.anyWorks}
        />
        <NoticeTextInput
            label={`mmia.${reportStep}.number`}
            id="number"
            formikProps={formikProps}
            disabled={buttonWorks.anyWorks || entry.demandId != null}
        />
        <NoticeTextInput
            label={`mmia.${reportStep}.name`}
            id="name"
            formikProps={formikProps}
            disabled={buttonWorks.anyWorks || entry.demandId != null}
        />
        <NoticeNumericInput
            label={`mmia.${reportStep}.contractValue`}
            id="contractValue"
            formikProps={formikProps}
            disabled={buttonWorks.anyWorks}
        />
    </>)
}

AnnualReportExceptionEditForm.propTypes = {
    entry: PropTypes.object.isRequired,
    newEntry: PropTypes.bool,
    buttonWorks: PropTypes.shape({anyWorks: PropTypes.bool.isRequired}).isRequired,
    reportStep: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired
}

export default AnnualReportExceptionEditForm;